import { observable } from "mobx";
import type PossibleExemptionType from "./possibleExemptionType";

export default class VehicleRegistrationsResponse {
  @observable
  isGivenExemption: boolean;

  @observable
  possibleExemption?: PossibleExemptionType;

  @observable
  chargeWasPurchasedBefore: boolean;
}
